// extracted by mini-css-extract-plugin
module.exports = {"commonbtnstyle":"Button_Common_commonbtnstyle__E_8mw","read-more":"Button_Common_read-more__Fn4A_","bluebgorangebtn":"Button_Common_bluebgorangebtn__5Vka4"};